import { calculateStepPricing } from '@/utils/modules/cart'
import StepPricingProvider from '@/resources/step_pricing_provider'
import { getCurrentBranchPOS } from '@/utils/helper/localStorage'
import PromotionProvider from '@/resources/promotion_provider'
const promotionProvider = new PromotionProvider()
const stepPricingProvider = new StepPricingProvider()

const state = {
  items: [],
  discount: 0,
  promotionCode: {},
  stepPricing: {},
  tel: ''
}

const actions = {
  async verifyPromoCode ({ commit, dispatch, state }, payload) {
    const res = await promotionProvider.verifyPromotionCode({
      code: payload.promoCode,
      memberTel: payload.tel,
      items: calculateStepPricing(state.items, state.stepPricing),
      warehouse: {
        id: parseInt(getCurrentBranchPOS().branch_id),
        name: getCurrentBranchPOS().warehouse_display_name,
        code: getCurrentBranchPOS().warehouse
      }
    })
    if (res.data.success) {
      commit('SET_PROMOTION_CODE', res.data.promotion_code)
      commit('SET_DISCOUNT', res.data.discount)
    } else {
      dispatch('clearDiscount')
    }
    return res
  },
  async addItem ({commit}, payload = '') {
    if (payload) {
      commit('CLEAR_DISCOUNT')
      commit('ADD_ITEM', payload)
      return true
    } else {
      return false
    }
  },
  removeItem ({commit}, payload) {
    commit('CLEAR_DISCOUNT')
    commit('REMOVE_ITEM', payload)
  },
  setTel ({commit}, payload) {
    commit('SET_TEL', payload)
  },
  clearAllData ({dispatch, commit}) {
    this.dispatch('clearMoney')
    this.dispatch('initState')
    commit('CLEAR_DISCOUNT')
    commit('CLEAR_ITEM_IN_CART')
    dispatch('setTel')
  },
  async fetchStepPricing ({commit}) {
    commit('SET_STEP_PRICING', await stepPricingProvider.getAllStepPricing())
  },
  clearDiscount ({commit}) {
    commit('CLEAR_DISCOUNT')
  }
}

const mutations = {
  ADD_ITEM: (state, payload) => {
    state.items.push(payload)
  },
  CLEAR_ITEM_IN_CART: (state) => {
    state.items = []
  },
  REMOVE_ITEM: (state, payload) => {
    const index = state.items.findIndex(item => item.id === payload.id)
    state.items.splice(index, 1)
  },
  CLEAR_DISCOUNT: (state) => {
    state.discount = 0
    state.promotionCode = {}
  },
  SET_PROMOTION_CODE: (state, payload) => {
    state.promotionCode = payload
  },
  SET_DISCOUNT: (state, payload) => {
    state.discount = payload
  },
  SET_TEL: (state, payload = '') => {
    state.tel = payload
  },
  SET_STEP_PRICING (state, payload) {
    state.stepPricing = payload
  }
}
const calTotalPrice = (state) => {
  let newItems = JSON.parse(JSON.stringify(state.items))
  newItems = calculateStepPricing(newItems, state.stepPricing)
  const tags = ['new']
  const productInclude = newItems.filter(item => item.tags ? item.tags.some(tag => tags.some(dis => dis === tag)) : false)
  const productExclude = newItems.filter(item => item.tags ? !item.tags.some(tag => tags.some(dis => dis === tag)) : true)
  let netPriceInclude = productInclude.reduce((sum, item) => sum + parseInt(item.priceDiscount), 0)
  let netPriceExclude = productExclude.reduce((sum, item) => sum + parseInt(item.priceDiscount), 0)
  // if (netPriceExclude >= 2000) {
  //   netPriceExclude = netPriceExclude * 0.8
  // } else if (netPriceExclude >= 1000) {
  //   netPriceExclude = netPriceExclude * 0.9
  // }

  return netPriceInclude + netPriceExclude
}
const getters = {
  getItems: (state) => {
    return calculateStepPricing(state.items, state.stepPricing)
  },
  getFullPrice: (state) => {
    return state.items.reduce((sum, item) => sum + parseInt(item.price), 0)
  },
  getNetPrice: (state) => {
    const netPrice = calTotalPrice(state) - state.discount
    return (netPrice <= 0) ? 0 : netPrice
  },
  getUndiscountPrice: (state) => {
    const result = calTotalPrice(state)
    return result
  },
  getItemsAmount: (state) => {
    return (state.items.reduce((sum, item) => sum + item.quantity, 0))
  },
  promotionCodeDetail: state => state.promotionCode,
  discount: state => state.discount,
  getTel: state => state.tel,
  getStepPricing: state => state.stepPricing,
  getPromoCodeDetails: state => state.promotionCode
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js